import { buttonGradients, ButtonGradientType } from "./button-gradients";
import { countdownGradients, CountdownGradientType } from "./countdown-gradients";

type DirectionType = "horizontal" | "vertical";

export const linearGradient = (
  direction: DirectionType = "horizontal",
  buttonGradient: ButtonGradientType = "blueToGreen"
): string => {
  const degree = direction === "horizontal" ? "94.47deg" : "180deg";
  const [startColor, endColor] = buttonGradients[buttonGradient];

  return `linear-gradient(${degree}, ${startColor} 0%, ${endColor} 51%, ${startColor} 100%)`;
};

export const verticalLinearGradient = (
  direction: DirectionType = "vertical",
  countdownGradient: CountdownGradientType = "darktolight"
): string => {
  const degree = direction === "vertical" ? "to bottom" : "to top";
  const [startColor, endColor] = countdownGradients[countdownGradient];

  return `linear-gradient(${degree}, ${startColor} 50%, ${endColor} 50%)`;
}

export const toCamelCase = (str: string) => {
  let ans = str.toLowerCase();

  return ans
    .split(" ")
    .reduce(
      (s: string, c: string) => s + (c.charAt(0).toUpperCase() + c.slice(1))
    );
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};